<template>
  <div class="table_bug_warp">
    <el-table :cell-style="getRowClass" row-key="id" class="table_bug" :header-cell-style="getRowClass" max-height="600"
      :data="bugs" :expand-row-keys="expands" @row-click="clickRowHandle" @sort-change="sortChange">
      <el-table-column type="expand">
        <template slot-scope="props">
          <pre v-html="props.row.description "></pre>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标题" prop="title">
      </el-table-column>
      <el-table-column align="center" label="状态" :formatter="formatterStatus" prop="status">
      </el-table-column>
      <el-table-column align="center" label="报告人" :formatter="formatterUser" prop="reporter">
      </el-table-column>
      <el-table-column align="center" label="环境" prop="env">
      </el-table-column>
      <el-table-column align="center" sortable="custom" label="创建时间" :formatter="formatterTime" prop="createTime">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: {
    bugOption: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      expands: [],
      STATUS: {
        new: '未解决',
        resolved: '已解决',
        closed: '已关闭'
      },
      bugs: []
    };
  },
  created() {
    this.bugs = this.bugOption.bugs;
  },
  computed: {
    ...mapState(
      {
        // 进度条
        allSelect: (state) => state.devOps.ALLSELECT,
      }
    ),
  },
  methods: {
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background:#f1fbec";
    },
    formatterTime(row) {
      if (!row.createTime) return;
      return this.$moment(row.createTime * 1).format("YYYY-MM-DD HH:mm:ss");
    },
    formatterUser(row) {

      return this.allSelect.TEXTUSERSEN[row.reporter]
    },
    formatterStatus(row) {
      return this.STATUS[row.status]
    },
    sortChange(column) {
      const { prop, order } = column;
      console.log(order)
      this.bugs.sort((a, b) => {
        switch (order) {
          case 'descending':
            return b[prop] - a[prop]
          case 'ascending':
            return a[prop] - b[prop]
          default:
            return b[prop] - a[prop]
        }
      })
      console.log(prop, order)
    },
    clickRowHandle(row) {
      if (this.expands.includes(row.id)) {
        this.expands = this.expands.filter(val => val !== row.id);
      } else {
        this.expands = []
        this.expands.push(row.id);
      }
    }
  },
};
</script>

<style  lang="scss">
.task_model_dialog_child {
  .el-table__body {
    cursor: pointer;
  }

  .el-dialog__body {
    padding: 0 20px 20px;
  }

  .el-dialog__header {
    font-weight: bold;
  }
}
</style>